import Keycloak from "keycloak-js";
import { KeycloakIDPAdapterBuilder } from "@sia/style-guide";
import { EncryptionProvider } from "common/crypto";

const IDPUrl = process.env.REACT_APP_IDP_URL;
const realm = process.env.REACT_APP_IDP_REALM;
const clientId = process.env.REACT_APP_IDP_CLIENT_ID;
const keycloakClient = Keycloak({ url: IDPUrl, realm, clientId });
const adapter = KeycloakIDPAdapterBuilder(keycloakClient, IDPUrl, realm, clientId);
const logout = adapter.logout;

let logoutInProgress = false;
const logoutListeners = new Set();

const publishLogoutState = (nextState) => {
  logoutInProgress = nextState;

  logoutListeners.forEach((listener) => {
    try {
      listener(nextState);
    } catch (error) {
      logoutListeners.delete(listener);
      console.error("Keycloak logout-state subscriber failed", error);
    }
  });
};

adapter.isLogoutInProgress = () => logoutInProgress;

adapter.subscribeLogoutState = (listener) => {
  if (typeof listener !== "function") {
    throw new TypeError("Logout-state subscriber must be a function");
  }

  logoutListeners.add(listener);
  listener(logoutInProgress);

  return () => logoutListeners.delete(listener);
};

adapter.logout = (redirectUrl, isBM = false) => {
  publishLogoutState(true);

  if (isBM) EncryptionProvider.purge();

  try {
    const result = logout(redirectUrl, isBM);

    return (
      result?.catch?.((error) => {
        publishLogoutState(false);
        throw error;
      }) || result
    );
  } catch (error) {
    publishLogoutState(false);
    throw error;
  }
};

export default adapter;
